import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/pages/products/industries/ads011.jpg")